var _style, _rect, _path, _path2, _polyline, _path3, _path4, _line, _line2, _line3, _line4, _line5, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _g, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSiteplan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 802 620",
    style: {
      enableBackground: "new 0 0 802 620"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#919798;stroke-width:3;}\n\t.st1{fill:#BCCDC7;stroke:#919798;stroke-width:3;}\n\t.st2{fill:none;stroke:#919798;}\n\t.st3{fill:#E6E8E9;stroke:#919798;}\n\t.st4{fill:#BCCDC7;stroke:#919798;stroke-width:2;}\n\t.st5{font-family:'Arial-BoldMT';}\n\t.st6{font-size:12px;}\n\t.st7{font-size:15px;}\n\t.st8{letter-spacing:3;}\n\t.st9{fill:#919798;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    className: "st0",
    width: 799,
    height: 617
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.5,94c0,0,11,88,18,146s19,118,19,183.5s0,150.5-8,195h-29V94z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.2,1.5l45.8,351c0,0,3.3,24.5,3.7,57.9c0,0-0.6,3.4,3.3,8.1c3.9,4.8,12.4,9.7,12.4,9.7l16.6-3.9l8.3-9 l19.4-15.9c0,0,10.7-11.8,11-12.2s10.9-9.7,11.3-10.1c0.4-0.4,15.7-7.4,16.5-7.6c0.8-0.2,20.3-6.2,20.3-6.2l28.1-8.5l94.6-34.8 l28.5-13.6l15.8-12.8l78.8-39.8l53.1-27.7l9.2-11.7l-0.3-9.8v-4.3l-8.9,1.8c0,0-8.2,3.2-8.9,3.3s-2.7-3.2-2.7-3.2l-10.8-41.5 l21.6-5.8l7.8-3.1l5.3-8.2l12.2-18.5c0,0,10.7-14.2,32.9-16.6c22.2-2.4,44.4,2.3,53.6,14.3s20.8,29.2,18.6,49.2 s-10.1,37.5-32.3,48.2s-50,23.4-63.1,29.3s-74.8,34.8-74.8,34.8l-35.8,20.3c0,0-17.8,8.7-19.3,9.3s-13.2,9.2-13.2,9.2l-23.7,13.4 l-38.6,15.9L314,367.2l-51.3,18l-40.8,13l-15.2,6.8l-8.5,4.8l-11.7,13l-14,12.5L155,450.2l-13.7,8.5c0,0-21.8,4-22.5,4 c-0.7,0-11.7,5.3-11.7,5.3l-2.8,4.5h-1.7l-0.7,65.2c0,0-3.5,66.2-6.2,80.8h704.8V1.5H52.2z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "506.7,183.9 528.8,177.5 530.5,183.2 508.4,189.6 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M216.6,205L256,348.2l53.9-19c0,0,35-11.3,55.2-23.5s53.5-30.4,72.5-40.9s70-35.6,70-35.6L478,126l48.8,23 c0,0,14-43.3,62.8-42.8c47.7,0.5,66.9,41.9,60.2,78.2c0,0-3.2,29.3-51.2,47.1s-139,66.4-139,66.4L436,310c0,0-18.5,10.8-36.5,21.5 s-48.8,25.2-75.5,34.2l-108.1,37.1c0,0-11.2,3.9-19.6,12.6s-31.2,28.6-31.2,28.6s-11.7,13.6-45.7,21.3l13.1,94.6l665.3-335.2 L693.5,18.2l-450.7,85.3l25.3,87.2L216.6,205z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M587.9,171.9l3.8,9.7c0,0,0.9,1.9-1,2.6l-14.2,5.5c0,0-4.4,1.1-2.7,4.6c1.7,3.4,14.9,6.8,26.2,2.4 c11.3-4.4,18.7-15.9,17.6-19.5c-1.1-3.7-5.1-1.5-5.1-1.5l-14.1,5.5c-1.9,0.8-2.5-1.2-2.5-1.2l-3.8-9.7l-6.3-16.1c0,0-0.9-1.9,1-2.6 l14.1-5.5c0,0,4.4-1.1,2.7-4.6c-1.7-3.4-14.9-6.8-26.2-2.4c-11.3,4.4-18.7,15.9-17.6,19.5c1.1,3.7,5.1,1.5,5.1,1.5l14.2-5.5 c1.9-0.8,2.5,1.2,2.5,1.2L587.9,171.9z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 588.7,
    y1: 174,
    x2: 568.8,
    y2: 181.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 584.8,
    y1: 163.9,
    x2: 564.9,
    y2: 171.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 612.7,
    y1: 164.6,
    x2: 592.8,
    y2: 172.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 608.7,
    y1: 154.5,
    x2: 588.8,
    y2: 162.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "_x3C_Path_x3E_",
    className: "st2",
    x1: 503.7,
    y1: 173.7,
    x2: 526.5,
    y2: 167.6
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_19_1_",
    "data-lot-num": 19,
    className: "lot st3",
    points: "307.8,331.3 256.5,350 216.6,205 267.3,190.8 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_18_1_",
    "data-lot-num": 18,
    className: "lot st3",
    points: "356.5,311.5 332.3,321.8 307.8,331.3 267.3,190.8 268.1,190.6 242.8,103.5 293.2,94.2 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_17_1_",
    "data-lot-num": 17,
    className: "lot st3",
    points: "406.5,284.1 356.5,313.9 293.2,94.2 348.6,83.5 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_16_1_",
    "data-lot-num": 16,
    className: "lot st3",
    points: "457.8,258.4 406.5,284.1 348.9,83.8 404.3,73.1 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_15_1_",
    "data-lot-num": 15,
    className: "lot st3",
    points: "508.9,232.5 457.8,258.4 410.7,94.8 478,126 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_14_1_",
    "data-lot-num": 14,
    className: "lot st3",
    points: "551.3,118.2 526.8,149 410.7,94.8 404.8,73.1 497.3,55.3 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_13_1_",
    "data-lot-num": 13,
    className: "lot st3",
    points: "593.7,105.9 570.9,110 550.5,117 498.2,55.5 612.9,33.4 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_12_1_",
    "data-lot-num": 12,
    className: "lot st3",
    points: "625,116.6 609.7,110 593.7,105.9 612.9,33.7 693.5,18.2 703,37.1 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_11_1_",
    "data-lot-num": 11,
    className: "lot st3",
    points: "644.9,143.5 625,116.6 703,37.1 740.2,110.7 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_10_1_",
    "data-lot-num": 10,
    className: "lot st3",
    points: "649.8,177.5 644.9,143.5 740.1,111.3 788.3,206 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_9_1_",
    "data-lot-num": 9,
    className: "lot st3",
    points: "704.4,271.9 634.9,207.4 649.8,177.5 788.3,206 797.8,224.8 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_8_1_",
    "data-lot-num": 8,
    className: "lot st3",
    points: "636.2,306.3 598.5,232.5 634.9,207.4 704.4,271.9 "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_7_1_",
    "data-lot-num": 7,
    className: "lot st3",
    points: "567.2,341 528.5,263.6 598.5,231.6 636.2,306.3 "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_6_1_",
    "data-lot-num": 6,
    className: "lot st3",
    points: "498.7,375.5 458.2,295.2 527.8,262.5 567.2,341 "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_5_1_",
    "data-lot-num": 5,
    className: "lot st3",
    points: "429.6,410.3 390.9,334.7 458.6,296 498.7,375.5 "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_4_1_",
    "data-lot-num": 4,
    className: "lot st3",
    points: "353.5,448.7 323.2,364.9 390.9,334.7 429.6,410.3 "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_3",
    "data-lot-num": 3,
    className: "lot st3",
    points: "298.9,476.2 253.2,388.9 323.2,364.9 353.5,448.7 "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_2",
    "data-lot-num": 2,
    className: "lot st3",
    points: "221.8,515 179.3,430.6 207,405.9 253.3,389.6 298,476.6 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Lot_1",
    "data-lot-num": 1,
    className: "lot st3",
    points: "132.5,560 118.8,462.7 151.7,452.2 178.5,429.1 221.8,515 "
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 162.4966 496.5)",
    className: "st5 st6"
  }, "1"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 233.4966 456.5)",
    className: "st5 st6"
  }, "2")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 303.9512 425.834)",
    className: "st5 st6"
  }, "3")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 373.3506 396.166)",
    className: "st5 st6"
  }, "4")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 441.6836 358.5)",
    className: "st5 st6"
  }, "5")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 509.6836 324.833)",
    className: "st5 st6"
  }, "6")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 581.417 291.166)",
    className: "st5 st6"
  }, "7")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 642.8301 260.834)",
    className: "st5 st6"
  }, "8")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 699.7017 225.834)",
    className: "st5 st6"
  }, "9")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 704.6982 162.2754)",
    className: "st5 st6"
  }, "10")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 675.0317 104.5)",
    className: "st5 st6"
  }, "11")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 626.0317 73.1123)",
    className: "st5 st6"
  }, "12")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 555.0317 78.7588)",
    className: "st5 st6"
  }, "13")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 484.3652 102.7588)",
    className: "st5 st6"
  }, "14")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 454.3652 179.4258)",
    className: "st5 st6"
  }, "15")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 397.8345 193.4258)",
    className: "st5 st6"
  }, "16")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 346.501 207.4258)",
    className: "st5 st6"
  }, "17")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 296.8345 224.0928)",
    className: "st5 st6"
  }, "18")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 245.5015 240.4902)",
    className: "st5 st6"
  }, "19")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.1204 0.9927 -0.9927 0.1204 27.8236 86.8106)",
    className: "st5 st7 st8"
  }, "MOUNT PLEASANT SREET")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 529.064 469.5)",
    className: "st5 st7 st8"
  }, "LION\u2019S PARK")), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M637.7,126.5c-7.9-10.1-22.3-22-46.1-22c-50.6,0-63.8,40.3-63.9,40.7c-1.2,3.7-3.5,4.8-3.8,4.9l-30.8,8.8 l15,50.8l17.6-5.6c0.9-0.3,1.4-0.3,1.7-0.3c0.1,0,0.2,0,0.2,0c0,0,0,0,0,0c-1.2,16.3-12.1,21.2-12.5,21.4l-60.3,30.4 c-31.9,15.4-64.4,33.4-85,47c-20.2,13.4-63.1,27.5-63.6,27.7L256,348.2l-60.5,20.6c-12,4-19.2,10.6-19.5,11 c-0.3,0.3-28.2,27.7-44,41.1c-13.6,11.6-26.5-1.7-27-2.3l-4.4-11.7v15.8c5.9,6.3,20.9,15,35.3,2.7c15.9-13.5,44-41.1,44.2-41.3 c0.1-0.1,6.6-6,17.3-9.6l60.5-20.6l50.2-17.7c1.8-0.6,44.1-14.5,64.9-28.3c20.3-13.5,52.6-31.3,84.3-46.6l60.1-30.3 c1.5-0.7,14.8-7.1,16.1-26.9l0-0.2l0-0.2c-0.1-1.4-0.8-3.4-2.6-4.6c-1.9-1.3-4.3-1.4-7.2-0.4l-11.7,3.7l-11.5-39.2l25.2-7.2 c0.6-0.2,5.6-1.9,7.7-8.8c0.1-0.4,11.9-36.5,58.2-36.5c21.3,0,34.3,10.7,41.3,19.7c11.8,15,16.5,36.7,12,55.1 c-0.1,0.3-7.7,26.5-47.6,41.8c-46.9,18.1-115.1,52.6-151.5,71.6c-0.2,0.1-20.6,10.2-38.7,21.7c-12,7.6-45.4,27.2-95,44 c-43,14.6-96.8,33.2-99,34c-1.2,0.4-14.1,4.5-23.3,15.5c-8.7,10.4-31.8,30.5-32,30.7l-0.2,0.2c-0.1,0.1-10.7,10.7-32.6,13.7 c-1.7,0.1-15,1.3-23.8,12.9l0.3,11.1l4.4-7.4c7.5-9.8,19.4-10.6,19.5-10.6l0.3,0c23.3-3.2,34.9-14.1,36.1-15.4 c1.8-1.6,23.8-20.7,32.6-31.3c8.3-9.9,20.3-13.6,20.5-13.6l0.1,0c0.5-0.2,55.3-19.2,99-34c50.2-17.1,84.1-36.9,96.3-44.6 c17.8-11.3,37.9-21.2,38.2-21.4c29.3-15.3,102.6-52.7,150.9-71.4c42.9-16.5,50.9-44.7,51.3-45.9 C655.8,166.6,650.6,142.9,637.7,126.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteplan);
export default __webpack_public_path__ + "static/media/siteplan.0029baa8.svg";
export { ForwardRef as ReactComponent };